import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    bluish: {},
    disabled: {},

    input: {
      width: '100%',
      padding: 0,
      alignSelf: 'flex-start',

      fontSize: theme.typography.pxToRem(14),

      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.short,
      }),

      '$bluish &': {
        '&:not($disabled)': {
          backgroundColor: COLORS.primary.silver,
        },
      },
    },
    outline: {
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,

      '$bluish &': {
        borderColor: COLORS.primary.silver,
      },
    },
    iconSearch: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.mediumGray,
      marginLeft: 10,
    },
  }),
  { name: 'SearchField' }
);
